import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Alert } from "@circle-react-shared/uikit/AlertV2";
import { Loader } from "@circle-react-uikit/Loader";
import { AddOns } from "../AddOns";
import { ScheduledSubscriptionBanner } from "../PlanSettings/TopSection/ScheduledSubscriptionBanner";
import { useCurrentPlanApi } from "../hooks/useCurrentPlanApi";
import { AiActionsBillingDetails } from "./AiActionsBillingDetails";
import { EmailHubBillingDetails } from "./EmailHubBillingDetails";
import { PlanFeatures } from "./PlanFeatures";
import { UpcomingInvoice } from "./UpcomingInvoice";

interface OldBillingDetailsProps {
  forceFromSubscription?: boolean;
  showAddons?: boolean;
  showBillingDetails?: boolean;
  showBillingPortal?: boolean;
}

export const OldBillingDetails = ({
  showBillingPortal,
  showAddons,
  forceFromSubscription = true,
  showBillingDetails = true,
}: OldBillingDetailsProps) => {
  const {
    currentPlan,
    isCurrentPlanLoading,
    errorFetchingCurrentPlan,
    refetchCurrentPlan,
  } = useCurrentPlanApi(forceFromSubscription);

  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.billing_page.visited", {});
  }, []);

  if (isCurrentPlanLoading) {
    return <Loader center />;
  }
  if (errorFetchingCurrentPlan || !currentPlan) {
    return (
      <Alert
        title={t("settings.billing.plans.errors.plan_not_found")}
        type="alert"
      />
    );
  }

  return (
    <>
      {currentPlan.scheduled_downgrade_metadata && (
        <div className="mb-8">
          <ScheduledSubscriptionBanner currentPlan={currentPlan} />
        </div>
      )}
      <PlanFeatures currentPlan={currentPlan} />

      {showAddons && (
        <AddOns
          currentPlan={currentPlan}
          refetchCurrentPlan={refetchCurrentPlan}
        />
      )}

      <EmailHubBillingDetails />

      <AiActionsBillingDetails />

      {showBillingDetails && (
        <UpcomingInvoice
          showBillingPortal={showBillingPortal}
          currentPlan={currentPlan}
        />
      )}
    </>
  );
};
